import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2, Mail } from "lucide-react";
import { api } from "@/lib/api";

const SubscribersManager = () => {
  const [subs, setSubs] = useState([]);

  const load = () => api.get("/subscribers").then((r) => setSubs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const exportCsv = async () => {
    try {
      const res = await api.get("/subscribers/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "subscribers.csv";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("CSV exported");
    } catch {
      toast.error("Export failed");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    await api.delete(`/subscribers/${id}`);
    load();
  };

  return (
    <div data-testid="subscribers-manager">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display font-extrabold text-2xl text-[#1A1A1A]">Subscribers ({subs.length})</h2>
        <button onClick={exportCsv} disabled={subs.length === 0} className="inline-flex items-center gap-2 rounded-full bg-[#7ED321] hover:bg-[#FF7A1A] text-white font-bold text-sm px-5 py-2.5 transition-colors disabled:opacity-50" data-testid="export-csv-btn">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>

      {subs.length === 0 ? (
        <div className="text-center py-16 text-[#1A1A1A]/40">
          <Mail className="w-10 h-10 mx-auto mb-3 opacity-40" />
          <p>No subscribers yet.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-[#1A1A1A]/5 overflow-hidden shadow-sm">
          {subs.map((s, i) => (
            <div key={s.id} className={`flex items-center gap-4 px-5 py-3.5 ${i !== subs.length - 1 ? "border-b border-[#1A1A1A]/5" : ""}`} data-testid={`subscriber-row-${s.id}`}>
              <div className="w-9 h-9 rounded-full bg-[#FFC93C]/25 flex items-center justify-center flex-shrink-0">
                <Mail className="w-4 h-4 text-[#FF7A1A]" />
              </div>
              <p className="flex-1 font-medium text-[#1A1A1A] truncate">{s.email}</p>
              <p className="text-sm text-[#1A1A1A]/40 hidden sm:block">{new Date(s.created_at).toLocaleDateString()}</p>
              <button onClick={() => remove(s.id)} className="p-2 rounded-lg hover:bg-[#FF3D68]/10 text-[#FF3D68]" data-testid={`delete-subscriber-${s.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SubscribersManager;
